<template>
  <div class="page">
    <div class="news">
      <div class="news-left">
        <div class="newsTitle">{{ props.data.titleCn }}</div>
        <div class="newsEn">{{ props.data.titleEn }}</div>
      </div>
      <div class="news-right" @click="jumpLink(props.data.jumpMore)">
        <img src="https://p5.ssl.qhimg.com/t110b9a9301b6b963a0112ea6ce.png" alt="">
      </div>
    </div>
    <div class="newsList">
      <div class="list-item" @click="jumpLink(item.linkUrl)" v-for="(item,index) in props.data.list" :key="index">
          <div class="item-title">{{item.title}}</div>
          <div class="item-desc van-multi-ellipsis--l2">{{item.desc}}</div>
          <div class="item-btn">
            <div class="item-time">{{item?.time}}</div>
            <img src="https://p2.ssl.qhimg.com/t110b9a93015d582d6db1af5e56.png" alt="">
          </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'

const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})

const jumpLink = (url) => {
  if (url) {
    window.open(url, '_blank')
  }
}

</script>

<style lang="scss" scoped>
.page{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .news {
    width: 1400px;
    display: flex;
    justify-content: center;
    // justify-content: space-between;
    align-items: center;
    position: relative;
    .news-left {
      // width: 660px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .newsTitle{
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 36px;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0px;
        text-transform: uppercase;
      }
      .newsEn{
        color: rgb(44, 44, 44);
        font-family: Rubik;
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0px;
        text-transform: uppercase;
        margin-top: 16px;
      }
    }
    .news-right {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 128px;
      img{
        cursor: pointer;
        width: 100%;
      }
    }
  }
  .newsList {
    width: 1400px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .list-item {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      width: calc(50% - 20px);
      // height: 250px;
      border-radius: 16px;
      margin-top: 64px;
      background: rgb(255, 255, 255);
      padding: 34px 40px;
      .item-title{
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 22px;
        font-weight: 500;
        line-height: 30px;
        letter-spacing: 0px;
        text-align: left;
        text-transform: uppercase;
        border-bottom: 0.5px solid rgb(177, 176, 176);
        height: 79px;
      }
      .item-desc{
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0px;
        text-align: justify;
        text-transform: uppercase;
        margin-top: 19px;
      }
      .item-btn{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
        .item-time{
          color: rgb(177, 176, 176);
          font-family: Source Han Sans;
          font-size: 16px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0px;
          text-align: left;
          text-transform: uppercase;
        }
        img{
          cursor: pointer;
          height: 18px;
        }
      }
      &:hover{
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.15);
      }
    }
  }
}
</style>
